import { ProfileComponent } from './profile/profile.component';
import { ProfileEditComponent } from './profile-edit/profile-edit.component';

export const containers: any[] = [ProfileComponent, ProfileEditComponent];

export * from './profile/profile.component';
export * from './profile-edit/profile-edit.component';
